<template>
    <div class="box_container">
         <div class="title line_bottom">
            <div class="info">
                    <div class="p_info">
                        <p class="tip1">{{guideInfo.name}}</p>
                        <p class="tip2"><i>{{guideInfo.certificate}}</i></p>
                    </div>
                    <p class="tip3">{{guideInfo.travelName}}</p>
            </div>
            <div class="head_logo" :style="'background-image:url(' + guideInfo.photoPath + ');'">

            </div>
        </div>
         <div class="container1">
              <div class="item line_bottom" v-if="type=='quiteBlacklist'" @click="editBlackPicker = true">
                   <!-- 退出黑名单弹框 -->
                   <div class="left">
                        <span>退出原因</span>
                        <span>*</span>
                   </div>
                   <div class="right">
                        <span :class="{'checkedWord': editBlackType !== '请选择'}">{{editBlackType}}</span>
                        <img class="r-img" src="../../assets/travelAgency/ic_righticon.png" />
                   </div>
              </div>
              <div class="item line_bottom" v-if="type=='quiteAllBlacklist'||type=='quiteAllBlacklistCity'" @click="editPicker = true">
                   <!-- 退出全国惩戒弹框 -->
                   <div class="left">
                        <span>退出原因</span>
                        <span>*</span>
                   </div>
                   <div class="right">
                        <span :class="{'checkedWord': editType !== '请选择'}">{{editType}}</span>
                        <img class="r-img" src="../../assets/travelAgency/ic_righticon.png" />
                   </div>
              </div>
              <p class="tip4">备注</p>
              <div class="content_reason">
                  <textarea class="content" placeholder="请输入备注说明…" v-model="reson" :maxLength="total"></textarea>
                  <span class="total">{{showCount}}/字</span>
              </div>
              <div class="file-contain">
                    <div class="file-title"><span>上传附件</span><span>*</span></div>
                    <div class="img-contain">
                        <div class="posting-uploader-item" v-for="(item,nn) in postData" :key="nn">
                            <img :src="item.content" alt="图片" class="imgPreview">
                            <img src="../../assets/guideSystem/delete.png" class="delte" @click="delImg(nn)">
                            <!-- <van-icon name="close" @click="delImg(nn)" class="delte"/> -->
                        </div>
                        <van-uploader :after-read="onRead" multiple="true" :accept="'image/*'">
                            <!-- <img src="../../assets/guideSystem/ic_upload.png" alt="等待传图" class="imgPreview"> -->
                        </van-uploader>
                    </div>
               </div>
               <div class="btn" :class="{'active':showBtn}" @click="confirm">提交</div>
         </div>
         <!-- 退出全国惩戒弹窗 -->
         <van-popup v-model="editPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="editColumns"
                @cancel="editPicker = false"
                @confirm="editConfirm"
            />
          </van-popup>
          <!-- 退出黑名单 -->
          <van-popup v-model="editBlackPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="editBlackColumns"
                @cancel="editBlackPicker = false"
                @confirm="editBlackConfirm"
            />
          </van-popup>
    </div>
</template>
<script>
    import api from '../../service/modules/guide'
    const HTTPS = 'https://'
    export default {
        data () {
            return {
                total: 200,
                postData: [], // 图片显示临时存储
                tempFile: [],
                uploadTemp: [],
                type: this.$route.query.type,
                guideId: this.$route.query.guideId,
                guideBlackId: this.$route.query.guideBlackId,
                editPicker: false, // 控制退出全国惩戒退出原因弹窗显示
                editColumns: ['惩戒到期', '其他'], // 控制退出全国惩戒退出原因
                editType: '请选择',
                editBlackPicker: false, // 控制退出全国惩戒退出原因弹窗显示
                editBlackColumns: ['监管到期', '其他'], // 控制退出全国惩戒退出原因
                editBlackType: '请选择',
                stateType: '', // 退出全国惩戒类型
                reson: '', // 原因
                guideInfo: {},
                back:this.$route.query.back||''
            }
        },
        computed: {
            showBtn () {
                if (this.type == 'quiteAllBlacklist' || this.type == 'quiteAllBlacklistCity') { // 退出全国惩戒
                    if (this.stateType && this.uploadTemp.length > 0) {
                        return true;
                    } else {
                        return false
                    }
                } else if (this.type == 'quiteBlacklist') { // 退出黑名单
                    if (this.editBlackType && this.uploadTemp.length > 0) {
                        return true;
                    } else {
                        return false
                    }
                }
            },
            showCount () {
                return this.total - parseInt(this.reson.trim().length)
            }
        },
        created () {
            this.getSession();
            this.getUserInfo();
            if (this.type == 'quiteAllBlacklist') { // 纳入黑名单惩戒
                window.yyn.invokeJSB(
                    'setTitle',
                    {
                        title: '退出惩戒' || ''
                    },
                    cb => {
                        console.log('设置title成功：', data);
                    }
                );
            } else if (this.type == 'quiteBlacklist') { // 纳入黑名单
                window.yyn.invokeJSB(
                    'setTitle',
                    {
                        title: '退出黑名单' || ''
                    },
                    cb => {
                        console.log('设置title成功：', data);
                    }
                );
            }
        },
        methods: {
            getUserInfo () { // 获取用户信息
                api.guideInfo({ id: this.guideId }).then(res => {
                    if (res.data) {
                        this.guideInfo = Object.assign({}, res.data);
                    } else {
                      this.$Toast('导游信息不存在')
                    }
                })
            },
            confirm () { // 提交
                if (this.type == 'quiteAllBlacklist' || this.type == 'quiteAllBlacklistCity') { // 退出全国惩戒
                    if (this.stateType == '') {
                        this.$Toast('请选择退出原因');
                    } else if (this.uploadTemp.length == 0) {
                        this.$Toast('请上传附件');
                    } else {
                        // if(this.type=='quiteAllBlacklist'){//全国
                        this.getCancelDiscipline();
                        // }else if(this.type=='quiteAllBlacklistCity'){//全省
                        //     alert(3);
                        // }
                    }
                } else if (this.type === 'quiteBlacklist') { // 退出黑名单
                    if (this.stateType == '') {
                        this.$Toast('请选择退出原因');
                    } else if (this.uploadTemp.length == 0) {
                        this.$Toast('请上传附件');
                    } else {
                        this.getBlackOut();
                    }
                }
            },
            // 退出黑名单提交
            getBlackOut () {
                let data = {
                    guideId: this.guideId,
                    disposeType: this.editBlackType,
                    disposeDesc: this.reson.trim(),
                    attach: JSON.stringify(this.uploadTemp)
                }
                api.guideCancel(data).then(res => {
                    if (res.ret === 0) {
                        this.$Toast.loading({
                            message: '提交成功',
                            icon: 'passed',
                            forbidClick: true
                        });
                    }
                    if(this.back){
                          if(this.back!='back'){
                               yyn.invokeJSB('closeWindow')
                          }
                    }else{
                        this.$router.go(-2);
                    }
                    // this.$router.go(-2);
                })
            },
            getCancelDiscipline () { // 退出全国惩戒
                const data = {
                    guideBlackId: this.guideBlackId,
                    disciplineDesc: this.reson.trim(),
                    attach: JSON.stringify(this.uploadTemp),
                    detailedType: this.editType,
                    type:this.back
                }
                console.log(data);
                api.cancelDiscipline(data).then(res => {
                    if (res.ret === 0) {
                        this.$Toast.loading({
                            message: '提交成功',
                            icon: 'passed',
                            forbidClick: true
                        });
                        if(this.back){
                        //   yyn.invokeJSB('closeWindow')
                            if(this.back!='back'){
                                yyn.invokeJSB('closeWindow')
                            }
                        //   this.$router.go(-1);
                        }else{
                            this.$router.go(-2);
                        }
                    }
                    // this.$router.go(-2);
                })
            },
            // 退出全国惩戒弹窗确认
            editConfirm (value) {
                this.editType = value;
                this.editPicker = false;
                if (value === '惩戒到期') {
                    this.stateType = '1';
                } else if (value === '其他') {
                    this.stateType = '2';
                }
            },
            // 退出黑名单确认
            // 退出全国惩戒弹窗确认
            editBlackConfirm (value) {
                this.editBlackType = value;
                this.editBlackPicker = false;
                if (value === '监管到期') {
                    this.stateType = '1';
                } else if (value === '其他') {
                    this.stateType = '2';
                }
            },
            onRead (file) { // 上传图片到图片服务器
                this.tempFile = []
                if (Array.isArray(file)) {
                    // 多图
                    for (let index = 0; index < file.length; index++) {
                        this.postData.push(file[index])
                        this.tempFile.push(file[index])
                    }
                } else {
                    // 单图
                    this.postData.push(file)
                    this.tempFile.push(file)
                }
                this.uploadFile()
            },
            getSession () {
                api.getCosSession().then(res => {
                    if (res.ret === 0) {
                        this.cosArg = res.data
                        this.cos = new COS({
                            getAuthorization: function (options, callback) {
                                callback({
                                    TmpSecretId: res.data.credentials && res.data.credentials.tmpSecretId,
                                    TmpSecretKey: res.data.credentials && res.data.credentials.tmpSecretKey,
                                    XCosSecurityToken: res.data.credentials && res.data.credentials.sessionToken,
                                    ExpiredTime: res.data.expiredTime
                                });
                            }
                        })
                    }
                });
            },
            uploadFile () {
                let cosKey = ''
                console.log('this.tempFile:', this.tempFile)
                for (let i = 0; i < this.tempFile.length; i++) {
                    cosKey = `${this.cosArg.keyPrefix}/${new Date().getTime()}/${this.tempFile[i].file.name}`
                    this.cos.putObject({
                        Bucket: this.cosArg.bucket,
                        Region: this.cosArg.region,
                        Key: cosKey,
                        Body: this.tempFile[i].file,
                        onHashProgress: function (progressData) {
                            console.log('校验中', JSON.stringify(progressData));
                        },
                        onProgress: function (progressData) {
                            console.log('上传中', JSON.stringify(progressData));
                        }
                    }, (err, res) => {
                        console.log(err, res);
                        if (!err) {
                            this.uploadTemp.push(HTTPS + res.Location)
                            console.log('this.uploadTemp:', this.uploadTemp)
                        }
                    })
                }
            },
            delImg (index) {
                // 删除指定下标的图片对象
                if (isNaN(index) || index >= this.postData.length) {
                    return false
                }
                let tmp = []
                let upTmp = []
                for (let i = 0, len = this.postData.length; i < len; i++) {
                    if (this.postData[i] !== this.postData[index]) {
                        tmp.push(this.postData[i])
                        upTmp.push(this.uploadTemp[i])
                    }
                }
                this.postData = tmp
                this.uploadTemp = upTmp
                console.log('this.uploadTemp:', this.uploadTemp)
            }
        }
    }
</script>
<style scoped lang="less">
.box_container{
    width:100%;
    .title{
        width:100%;
        padding:24px 12px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .info{
            .p_info{
                display: flex;
                flex-direction: row;
                align-items: center;
                .tip1{
                    font-size:20px;
                    color:#333;
                    font-weight: 700;
                }
                .tip2{
                    border:1px solid #36B374;
                    margin-left:8px;
                    i{
                        display: inline-block;
                        font-size: 12px;
                        color:#36B374;
                        padding:4px;
                    }
                }
            }
            .tip3{
                font-size:12px;
                color:#999999;
                margin-top:13px;
            }
        }
        .head_logo{
            width:49px;
            height:49px;
            background: url(../../assets/travelAgency/ic_bm_cy1.png);
            border-radius: 3px;
            border: 1px solid rgba(238, 238, 238, 1);
            background-size: auto 100%;
            background-position: center;
            background-repeat: no-repeat;
        }
    }
    .container1{
        width:100%;
        padding:0 12px;
        box-sizing: border-box;
        .item{
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            .left{
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                span:nth-child(1){
                    font-size:14px;
                    color:#999;
                }
                span:nth-child(2){
                    font-size:14px;
                    color:red;
                }
            }
            .right{
                display: flex;
                flex-direction: row;
                align-items: center;
                span{
                    font-size:14px;
                    color:#999;
                }
                .checkedWord {
                    color: #333333;
                }
                img{
                    width:12px;
                    height:12px;
                    margin-left:2px;
                    padding:15px 0;
                }
            }
        }
        .tip4{
            font-size:14px;
            color:#999999;
            padding:16px 0 12px 0;
            box-sizing: border-box;
        }
        .content_reason{
            width:100%;
            height:180px;
            background-color: #F9F9F9;
            border-radius: 3px;
            position:relative;
            .content{
                width:100%;
                height:100%;
                border:0;
                outline: none;
                resize: none;
                padding:16px;
                font-size: 14px;
                color:#999;
                box-sizing: border-box;
                line-height: 1.3em;
            }
            .total{
                font-size:14px;
                color:#666;
                position:absolute;
                right:16px;
                bottom:16px;
            }

        }

        .file-contain{
            display: flex;
            flex-direction: column;
            margin-top:16px;
            .file-title{
                // font-size:14px;
                // font-family:PingFangSC-Regular,PingFang SC;
                // font-weight:400;
                // color:rgba(51,51,51,1);
                // line-height:14px;
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                span:nth-child(1){
                    font-size:14px;
                    color:#999;
                }
                span:nth-child(2){
                    font-size:14px;
                    color:red;
                }
            }
            .img-contain{
                display: flex;
                flex-wrap: wrap;
                margin-top: 13px;
                .posting-uploader-item{
                    width: 77px;
                    height: 77px;
                    position: relative;
                    margin-right: 13px;
                    margin-bottom: 13px;
                    .imgPreview{
                        width: 100%;
                        height: 100%;
                    }
                    .delte{
                        width: 14px;
                        height: 14px;
                        position: absolute;
                        top: -7px;
                        right: -7px;
                        z-index: 10;
                    }
                }
                .van-uploader{
                    position: relative;
                    top: 0!important;
                }
                .imgPreview{
                    width: 77px;
                    height: 77px;
                }
            }
        }
        .btn{
            width:100%;
            height:50px;
            text-align: center;
            line-height: 50px;
            color:#fff;
            background:rgba(54, 179, 116, .3);
            margin-top:25px;
            font-size:16px;
        }
        .active{
            background-color: rgb(54, 179, 116);
        }
    }
}
</style>
